import { PaymentApprovalService } from "../../src/services/PaymentApprovalService";
import { PaymentApprovalConstants } from "../constants/PaymentApprovalConstants";
import { alertActions } from ".";

export const PaymentApprovalActions = {
  getAll,
  getSubAll,
  createCatagory,
  updateCategory,
  openDialog,
  inActiveRow,
  inActiveRow2,
  onHideShow,
  onHideShow2,
  loadingData,
  loadingData2,
  onHideShowIsActive,
  onHideShowIsActive2,
  getCategoryDDL,
  createSubCategory,
  SubUpdateCategory,
  getSubCategoryDDL,
};

function getAll(data) {
  return (dispatch) => {
    dispatch(request());
    PaymentApprovalService.getCategory(data).then(
      (response) => {
        dispatch(loadingData(false));
        dispatch(success(response.ResponseData));
      },
      (error) => {
        dispatch(loadingData(false));
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: PaymentApprovalConstants.GETALL_REQUEST };
  }
  function success(datas) {
    return { type: PaymentApprovalConstants.GETALL_SUCCESS, datas };
  }
  function failure(error) {
    return { type: PaymentApprovalConstants.GETALL_FAILURE, error };
  }
}

function getSubAll(data) {
  return (dispatch) => {
    dispatch(request());
    PaymentApprovalService.getSubCategory(data).then(
      (response) => {
        dispatch(loadingData2(false));
        dispatch(success(response.ResponseData));
      },
      (error) => {
        dispatch(loadingData2(false));
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: PaymentApprovalConstants.GETSUBALL_REQUEST };
  }
  function success(datas) {
    return { type: PaymentApprovalConstants.GETSUBALL_SUCCESS, datas };
  }
  function failure(error) {
    return { type: PaymentApprovalConstants.GETSUBALL_FAILURE, error };
  }
}

function createCatagory(data, obj) {

  return (dispatch) => {
    dispatch(request(data));
    PaymentApprovalService.createCategory(data).then(
      (response) => {
        //history.push('/');
        if (response && response.ResponseCode) {
          if (response.ResponseCode === "200") {

            dispatch(success(response.ResponseData));
            dispatch(onHideShow(false));
            dispatch(getAll(obj));
            dispatch(alertActions.success(response.ResponseMessage));
          } else if (response.ResponseCode === "400") {
            dispatch(alertActions.warning(response.ResponseMessage));
          } else {
            dispatch(alertActions.error(response.ResponseMessage));
          }
        }
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: PaymentApprovalConstants.CREATE_REQUEST, data };
  }
  function success(data) {
    return { type: PaymentApprovalConstants.CREATE_SUCCESS, data };
  }
  function failure(error) {
    return { type: PaymentApprovalConstants.CREATE_FAILURE, error };
  }
}

function createSubCategory(data) {
  return (dispatch) => {
    dispatch(request(data));
    PaymentApprovalService.createSubCategory(data).then(
      (response) => {
        //history.push('/');
        if (response && response.ResponseCode) {
          if (response.ResponseCode === "200") {
            ;
            dispatch(success(response.ResponseData));
            dispatch(onHideShow(false));
            dispatch(alertActions.success(response.ResponseMessage));
          } else if (response.ResponseCode === "400") {
            dispatch(alertActions.warning(response.ResponseMessage));
          } else {
            dispatch(alertActions.error(response.ResponseMessage));
          }
        }
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: PaymentApprovalConstants.CREATE_REQUEST, data };
  }
  function success(data) {
    return { type: PaymentApprovalConstants.CREATE_SUCCESS, data };
  }
  function failure(error) {
    return { type: PaymentApprovalConstants.CREATE_FAILURE, error };
  }
}



function updateCategory(data) {
  return (dispatch) => {
    dispatch(request(data));
    PaymentApprovalService.updateCategory(data).then(
      (response) => {
        //history.push('/');
        if (response && response.ResponseCode) {
          ;
          if (response.ResponseCode === "200") {
            dispatch(success(data));
            dispatch(onHideShow(false));
            dispatch(alertActions.success(response.ResponseMessage));
          } else if (response.ResponseCode === "400") {
            dispatch(alertActions.warning(response.ResponseMessage));
          } else {
            dispatch(alertActions.error(response.ResponseMessage));
          }
        }
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: PaymentApprovalConstants.UPDATE_REQUEST, data };
  }
  function success(data) {
    return { type: PaymentApprovalConstants.UPDATE_SUCCESS, data };
  }
  function failure(error) {
    return { type: PaymentApprovalConstants.UPDATE_FAILURE, error };
  }
}

function SubUpdateCategory(data) {
  return (dispatch) => {
    dispatch(request(data));
    PaymentApprovalService.SubUpdateCategory(data).then(
      (response) => {
        //history.push('/');
        if (response && response.ResponseCode) {
          ;
          if (response.ResponseCode === "200") {
            dispatch(success(data));
            dispatch(onHideShow(false));
            dispatch(alertActions.success(response.ResponseMessage));
          } else if (response.ResponseCode === "400") {
            dispatch(alertActions.warning(response.ResponseMessage));
          } else {
            dispatch(alertActions.error(response.ResponseMessage));
          }
        }
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: PaymentApprovalConstants.UPDATE_REQUEST, data };
  }
  function success(data) {
    return { type: PaymentApprovalConstants.UPDATE_SUCCESS, data };
  }
  function failure(error) {
    return { type: PaymentApprovalConstants.UPDATE_FAILURE, error };
  }
}


function inActiveRow(category, isActive,obj) {
  var data = {
    DealerId: category,
    IsActive: isActive,
  };
  return (dispatch) => {
    dispatch(request());

    PaymentApprovalService.inActiveRow(category, isActive).then(
      (response) => {
        debugger
        if (response && response.ResponseCode) {
          if (response.ResponseCode === "200") {
            dispatch(success(data));
            dispatch(onHideShowIsActive(false));
            dispatch(alertActions.success(response.ResponseMessage));
            dispatch(getAll(obj))
          } else if (response.ResponseCode === "400") {
            dispatch(alertActions.warning(response.ResponseMessage));
          } else {
            dispatch(alertActions.error(response.ResponseMessage));
          }
        }
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: PaymentApprovalConstants.ISACTIVE_REQUEST };
  }
  function success(data) {
    return { type: PaymentApprovalConstants.ISACTIVE_SUCCESS, data };
  }
  function failure(error) {
    return { type: PaymentApprovalConstants.ISACTIVE_FAILURE, error };
  }
}

function inActiveRow2(category, isActive) {
  var data = {
    SubCatId: category,
    IsActive: isActive,
  };
  return (dispatch) => {
    dispatch(request());

    PaymentApprovalService.inActiveRow2(category, isActive).then(
      (response) => {
        if (response && response.ResponseCode) {
          if (response.ResponseCode === "200") {
            dispatch(success(data));
            dispatch(onHideShowIsActive(false));
            dispatch(alertActions.success(response.ResponseMessage));
          } else if (response.ResponseCode === "400") {
            dispatch(alertActions.warning(response.ResponseMessage));
          } else {
            dispatch(alertActions.error(response.ResponseMessage));
          }
        }
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: PaymentApprovalConstants.ISACTIVE2_REQUEST };
  }
  function success(data) {
    return { type: PaymentApprovalConstants.ISACTIVE2_SUCCESS, data };
  }
  function failure(error) {
    return { type: PaymentApprovalConstants.ISACTIVE2_FAILURE, error };
  }
}

function onHideShow(isbool) {
  return {
    type: PaymentApprovalConstants.DIALOG_REQUEST,
    isbool,
  };
}


function onHideShow2(isbool) {
  return {
    type: PaymentApprovalConstants.DIALOG_REQUEST2,
    isbool,
  };
}

function loadingData(isbool) {
  return {
    type: PaymentApprovalConstants.LOADING_REQUEST,
    isbool,
  };
}
function loadingData2(isbool) {
  return {
    type: PaymentApprovalConstants.LOADING_REQUEST2,
    isbool,
  };
}
function onHideShowIsActive(isbool) {
  return {
    type: PaymentApprovalConstants.DIALOG_ISACTIVE_REQUEST,
    isbool,
  };
}
function onHideShowIsActive2(isbool) {
  return {
    type: PaymentApprovalConstants.DIALOG_ISACTIVE_REQUEST2,
    isbool,
  };
}

function openDialog(data) {
  return {
    type: PaymentApprovalConstants.OPEN_DIALOG_REQUEST,
    data,
  };
}

function getCategoryDDL(data, flag) {
  return (dispatch) => {
    dispatch(request());
    PaymentApprovalService.fetchCategoryDLL(data).then(
      (response) => {


        // if (flag == 1) {
        //   response.ResponseData.splice(0, 0, { label: "All", value: "0" });
        // }
        dispatch(success(response.ResponseData));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: PaymentApprovalConstants.GETCATEGORYDDL_REQUEST };
  }
  function success(datas) {
    return { type: PaymentApprovalConstants.GETCATEGORYDDL_SUCCESS, datas };
  }
  function failure(error) {
    return { type: PaymentApprovalConstants.GETCATEGOYRDDL_FAILURE, error };
  }
}


function getSubCategoryDDL(data) {
  return (dispatch) => {
    dispatch(request());
    PaymentApprovalService.fetchSubCategoryDLL(data).then(
      (response) => {

        // if (flag == 1) {
        //   response.ResponseData.splice(0, 0, { label: "All", value: "0" });
        // }
        dispatch(success(response.ResponseData));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: PaymentApprovalConstants.GETSUBCATEGORYDDL_REQUEST };
  }
  function success(datas) {
    return { type: PaymentApprovalConstants.GETSUBCATEGORYDDL_SUCCESS, datas };
  }
  function failure(error) {
    return { type: PaymentApprovalConstants.GETSUBCATEGORYDDL_FAILURE, error };
  }
}